import React from 'react';
import styled from 'styled-components';
import { system } from './system';

// Molekule Field source:
// position: relative; transition: 175ms;
// & + & { margin-top: 1rem; }
// It is a layout wrapper — not a react-final-form Field.

interface FieldSys {
  [key: string]: any;
}

interface FieldProps {
  children?: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  $sys?: FieldSys;
  [key: string]: any;
}

const StyledField = styled.div<{ $sys?: FieldSys }>`
  position: relative;
  transition: 175ms;

  & + & {
    margin-top: 1rem;
  }

  ${(p: any) => system(p.$sys, p.theme)}
`;

const Field: React.FC<FieldProps> = ({
  $sys,
  className,
  style,
  children,
  ...rest
}) => {
  // Strip any non-DOM props that callers might pass (styles, etc.)
  const { styles, ...domRest } = rest as any;
  return (
    <StyledField $sys={$sys} className={className} style={style} {...domRest}>
      {children}
    </StyledField>
  );
};

export default Field;
